/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkScenarioDependencyCommitRequestSchema = z.object({
  sessionId: z.string().min(1),
});
